// extracted by mini-css-extract-plugin
module.exports = {"phoneNumber":"MessageContent_phoneNumber__zG71q"};